import React, { useState } from "react";
import { getServerImage, short_text } from "../../helpers/api";

const ToggleTabs = ({content,renter_blocks,landlord_blocks}) => {
  console.log(renter_blocks, landlord_blocks);
  const [activeTab, setActiveTab] = useState("landlord");

  return (
    <div>
      {/* Tabs */}
      <div className="toggle-tabs">
        <button
          className={activeTab === "landlord" ? "tab active" : "tab"}
          onClick={() => setActiveTab("landlord")}
        >
          {content?.featured_link_text1}
        </button>
        <button
          className={activeTab === "renter" ? "tab active" : "tab"}
          onClick={() => setActiveTab("renter")}
        >
          {content?.featured_link_text2}
        </button>
      </div>

      {/* Conditional Content */}
      <div className="tab-content">
        {activeTab === "landlord" && (
          <div>
            <div className="service_one new_servcies">
              <div className="contain">
                {/* Service Block 1 */}
                {landlord_blocks?.map((item) => (
                    <div className="flex" key={item.id}>
                      <div className="colL">
                        <div className="image">
                          <img
                            src={`${getServerImage("storage/images/",item.image)}`} // change to your path e.g., `/uploads/${item.image}`
                            alt={short_text(item?.txt1, 50)}
                          />
                        </div>
                      </div>
                      <div className="colR">
                        <div className="inner">
                          <div
                            className="sec_heading"
                            dangerouslySetInnerHTML={{ __html: item.txt1 }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === "renter" && (
          <div>
           <div className="service_one new_servcies">
              <div className="contain">
                {renter_blocks?.map((item) => (
                    <div className="flex" key={item.id}>
                      <div className="colL">
                        <div className="image">
                          <img
                            src={`${getServerImage("storage/images/",item.image)}`} // change to your path e.g., `/uploads/${item.image}`
                            alt={short_text(item?.txt1, 50)}
                          />
                        </div>
                      </div>
                      <div className="colR">
                        <div className="inner">
                          <div
                            className="sec_heading"
                            dangerouslySetInnerHTML={{ __html: item.txt1 }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ToggleTabs;
